import React, { useEffect } from "react";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import AppealRequestComponentLegacy from "../../../components/applicationComponents/legacy/appealRequest/appealRequestComponentLegacy";

export default function AppealRequestPageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Appeal Request",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <AppealRequestComponentLegacy disabled={false} showBack={true} showEdit={false} />
    </>
  );
}
